import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbConfigSkin extends AppService {

  abstract getConfigSkin(): Observable<any>;
  abstract getSkinCor(): Observable<any>;
  abstract setThemeSkin(themeColor: string): void;
}